const flows = {
  parent_flow_1: [
    ['set_user_email'],
    ['set_user_password_and_confirm', 'set_parental_unit_name'],
    ['add_child_info'],
    [
      'set_legal_first_name',
      'set_legal_last_name',
      'set_legal_address',
      'set_user_date_of_birth',
      'set_user_ssn_last4',
      'accept_terms'
    ],
    ['set_initial_funding_amount'],
    ['set_funding_account'],
    ['complete']
  ],
  approver_flow_2: [
    ['set_user_email'],
    [
      'set_user_password_and_confirm',
      'set_parental_unit_name',
      'set_user_date_of_birth'
    ],
    ['complete']
  ],
  parent_flow_5: [
    ['set_user_email', 'set_user_password', 'set_parental_unit_name'],
    ['add_child_info'],
    [
      'set_legal_first_name',
      'set_legal_last_name',
      'set_legal_address',
      'set_user_date_of_birth',
      'set_user_ssn_last4',
      'accept_terms'
    ],
    ['set_initial_funding_amount', 'set_funding_account'],
    ['complete']
  ],
  parent_flow_6: [
    [
      'set_user_email',
      'set_user_password',
      'set_parental_unit_name',
      'set_referral_code'
    ],
    ['add_child_info'],
    [
      'set_legal_first_name',
      'set_legal_last_name',
      'set_legal_address',
      'set_user_date_of_birth',
      'set_user_ssn_last4',
      'accept_terms'
    ],
    ['set_initial_funding_amount'],
    ['set_funding_account'],
    ['set_plan'],
    ['complete']
  ],
  parent_flow_7: [
    ['set_user_email', 'set_user_password', 'set_parental_unit_name'],
    ['set_initial_funding_amount'],
    ['set_funding_account'],
    [
      'set_legal_first_name',
      'set_legal_last_name',
      'set_legal_address',
      'set_user_date_of_birth',
      'set_user_ssn_last4',
      'accept_terms'
    ],
    ['add_child_info'],
    ['complete']
  ],
  parent_flow_8: [
    ['set_user_email', 'set_user_password', 'set_parental_unit_name'],
    ['add_child_info'],
    ['set_legal_address'],
    [
      'set_legal_first_name',
      'set_legal_last_name',
      'set_user_date_of_birth',
      'set_user_ssn_last4',
      'accept_terms'
    ],
    ['set_initial_funding_amount'],
    ['set_funding_account'],
    ['complete']
  ],
  parent_flow_9: [
    ['set_user_email', 'set_user_password', 'set_parental_unit_name'],
    ['add_child_info'],
    ['set_legal_address'],
    [
      'set_legal_first_name',
      'set_legal_last_name',
      'set_user_date_of_birth',
      'set_user_ssn_last4',
      'accept_terms'
    ],
    ['set_initial_funding_amount', 'set_autofunding_preference'],
    ['set_funding_account'],
    ['complete']
  ],
  child_flow_3: [
    ['set_user_email', 'set_user_password_and_confirm', 'set_user_gender'],
    ['set_parent_phone_number', 'set_user_first_name', 'set_user_last_name'],
    ['complete']
  ],
  parent_flow_10: [
    [
      'set_user_email',
      'set_user_password',
      'set_parental_unit_name',
      'set_referral_code'
    ],
    ['set_plan'],
    ['add_child_info'],
    [
      'set_legal_first_name',
      'set_legal_last_name',
      'set_legal_address',
      'set_user_date_of_birth',
      'set_user_ssn_last4',
      'accept_terms'
    ],
    ['set_initial_funding_amount'],
    ['set_funding_account'],
    ['complete']
  ],
  parent_flow_11: [
    [
      'set_user_email',
      'set_user_password',
      'set_parental_unit_name',
      'set_referral_code'
    ],
    ['set_plan'],
    ['add_child_info'],
    [
      'set_legal_first_name',
      'set_legal_last_name',
      'set_legal_address',
      'set_user_date_of_birth',
      'set_user_ssn_last4',
      'accept_terms'
    ],
    ['set_initial_funding_amount'],
    ['set_funding_account'],
    ['complete']
  ],
  parent_flow_12: [
    [
      'set_user_email',
      'set_user_password',
      'prove_prefill',
      'set_parental_unit_name',
      'set_referral_code'
    ],
    ['add_child_info'],
    ['prove_review'],
    [
      'set_legal_first_name',
      'set_legal_last_name',
      'set_legal_address',
      'set_user_date_of_birth',
      'set_user_ssn_last4',
      'accept_terms'
    ],
    ['set_initial_funding_amount'],
    ['set_funding_account'],
    ['complete']
  ],
  parent_flow_13: [
    [
      'set_user_email',
      'set_user_password',
      'prove_prefill',
      'set_parental_unit_name'
    ],
    ['set_plan'],
    ['add_child_info'],
    ['prove_review'],
    [
      'set_legal_first_name',
      'set_legal_last_name',
      'set_legal_address',
      'set_user_date_of_birth',
      'set_user_ssn_last4',
      'accept_terms'
    ],
    ['set_initial_funding_amount'],
    ['set_funding_account'],
    ['complete']
  ],
  parent_flow_14: [
    [
      'set_user_email',
      'set_user_password',
      'prove_prefill',
      'set_parental_unit_name'
    ],
    ['add_child_info'],
    ['prove_review'],
    [
      'set_legal_first_name',
      'set_legal_last_name',
      'set_legal_address',
      'set_user_date_of_birth',
      'set_user_ssn_last4',
      'accept_terms'
    ],
    ['set_initial_funding_amount'],
    ['set_funding_account'],
    ['complete']
  ],
  parent_flow_15: [
    ['set_user_email', 'set_user_password', 'set_parental_unit_name'],
    ['set_plan'],
    ['add_child_info'],
    ['prove_prefill'],
    ['prove_review'],
    [
      'set_legal_first_name',
      'set_legal_last_name',
      'set_legal_address',
      'set_user_date_of_birth',
      'set_user_ssn_last4',
      'accept_terms'
    ],
    ['set_initial_funding_amount'],
    ['set_funding_account'],
    ['complete']
  ],
  parent_flow_16: [
    [
      'set_user_email',
      'set_user_password',
      'set_parental_unit_name',
      'set_referral_code'
    ],
    [
      'set_legal_first_name',
      'set_legal_last_name',
      'set_legal_address',
      'set_user_date_of_birth',
      'set_user_ssn_last4',
      'accept_terms'
    ],
    ['credit_application'],
    ['set_funding_account'],
    ['complete']
  ],
  parent_flow_17: [
    [
      'set_user_email',
      'set_user_password',
      'set_parental_unit_name',
      'set_referral_code'
    ],
    ['add_child_info'],
    [
      'set_legal_first_name',
      'set_legal_last_name',
      'set_legal_address',
      'set_user_date_of_birth',
      'set_user_ssn_last4',
      'accept_terms'
    ],
    ['credit_application'],
    ['set_funding_account'],
    ['complete']
  ]
};

export default flows;
